import modal from 'views/modal/modal';
import userModel from 'models/user-model';
import ErrorBox from 'views/error-box/error-box';

const UpdateUserStatusDialog = {
    oninit: ({state}) => {
        state.status = userModel.user.status;
    },
    
    onremove: () => delete userModel.modifyUserError,

    view: ({state}) => {
        return <div class="create-account">
            <ErrorBox error={userModel.modifyUserError}/>
            <h3 class="account-modal-header">Change Status</h3>
            <div>
                <fieldset>
                    <div class="select-wrapper">
                        <select value={state.status}
                            onchange={(e) => {
                                state.status = e.target.value;
                            }}
                        >
                            <option>active</option>
                            <option>pending</option>
                            <option>invited</option>
                            <option>trial</option>
                            <option>suspended</option>
                        </select>
                    </div>
                </fieldset>
                <div class="create-account-btn-wrap">
                    <button class="btn account-submit-button" 
                        onclick={() => {
                            userModel.updateUser(state);
                        }}
                    >
                        {userModel.loading ? <div class="update-account-information-button spinner spinning"/> : 'Update'}
                    </button>
                    <div class="account-modal-buttons btn btn-secondary" onclick={() => modal.close()}>
                        Cancel
                    </div>
                </div>
            </div>
        </div>;
    }
};

export default UpdateUserStatusDialog;
